import React from "react";
import email from "../assets/img/email_brown_icon.svg"
import img10 from "../assets/img/10.jpg"
const ContactSection = () => {
  return (
    <>
      <div
        class="content_2_uni_head"
        style={{ backgroundImage: `url(${img10})` }}
      >
        <div>
          <h1>Contacts</h1>
        </div>
      </div>

      <div class="content_2_contacts_wrapper">
        <div>
          <div class="content_2_contact_sides">
            <div class="content_2_cotacts_info">
              <header>
                <h2>Reach Out to Us Anytime</h2>
                <p>
                  Got a question or feedback? We're here to help! Reach out to
                  us today and let’s enhance your aufantasy experience together!
                </p>
              </header>
              <div class="content_2_contacts_list">
                <article>
                  <div class="icon">
                    <img src={email} alt="" />
                  </div>
                  <div class="inner">
                    <p>Email Info</p>
                    <h3>
                      <a href="#">
                        <span
                          class="__cf_email__"
                          data-cfemail="1c75727a735c7a7d72687d6f657273326f756879"
                        >
                          [email&#160;protected]
                        </span>
                      </a>
                    </h3>
                  </div>
                </article>
              </div>
            </div>
            <div class="content_2_contacts_form">
              <h2>We’d love to hear from you!</h2>
              <form method="get" action="https://aufantasy.site/">
                <div class="content_2_input_item">
                  <label>
                    <input
                      type="text"
                      placeholder="First Name Last Name"
                      required
                    />
                  </label>
                </div>
                <div class="content_2_input_item">
                  <label>
                    <input type="text" placeholder="E-mail" required />
                  </label>
                </div>
                <div class="content_2_input_item">
                  <label>
                    <input type="text" placeholder="Subject" required />
                  </label>
                </div>
                <div class="content_2_input_item">
                  <label>
                    <textarea placeholder="Message" required></textarea>
                  </label>
                </div>
                <div class="content_2_form_button">
                  <button type="submit">Send</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSection;
